import styles from './styles.module.scss';

export const getBarStyle = length =>
  ({
    1: styles.noBar,
    2: styles.shortBar,
    3: styles.mediumBar,
    4: styles.mediumBar
  }[length] || styles.longBar);
